import script from "./QuestionsSelectionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsSelectionComponent.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsSelectionComponent.vue?vue&type=style&index=0&id=abbe9d26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abbe9d26"]])

export default __exports__